import request, { METHODS } from "src/utils/api-base";

const categoryApis = {
  // Create new category
  createCategory: (payload: any) => {
    return request({
      route: "/app/categories",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  // Get category list (paginated)
  getCategoryList: (params: {
    page: number;
    limit: number;
    status?: "active" | "inactive";
  }) => {
    return request({
      route: "/app/categories",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  // Edit category
  editCategory: (payload: any) => {
    return request({
      route: `/app/categories/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },
};

export default categoryApis;
